module.exports = __webpack_public_path__ + "img/Iowa outline.5bf4047a.png";